import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { License } from "src/app/shared/models/license.model";
import { VenueKitchenDevicePreferences } from "src/app/shared/models/VenueKitchenDevicePreferences.entity";

@Component({
	selector: "app-kitchen-setup",
	templateUrl: "./kitchen-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class KitchenSetupComponent implements OnInit {
	changesToSave: boolean = false;

	graphicsMode = [
		{
			label: "Standard",
			value: 0,
		},
		{
			label: "HD",
			value: 1,
		},
		{
			label: "Ultra",
			value: 2,
		},
	];

	kitchenDeviceSelected: License;
	kitchenDevicePreferences: VenueKitchenDevicePreferences;

	viewMode: number = 0;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.init();
		this.venueService.subscriptionVenueKey.subscribe((data) => {
			if (data && data !== 0) {
				this.kitchenPreferences(this.venueService.venueKey);
			}
		});
	}

	async init() {
		this.app.loading(true);

		if (this.venueService.licenses.value.length === 0) {
			this.venueService.licensesGet(this.venueService.venueKey);
		}

		this.app.loading(false);
	}

	async kitchenPreferences(venueKey: number) {
		const resp = await this.focuslink.kitchenDevicePreferencesGet(venueKey);
		this.kitchenDevicePreferences = new VenueKitchenDevicePreferences(resp);
	}

	async kitchenPreferencesSave() {
		const resp = await this.focuslink.kitchenDevicePreferencesPost(this.venueService.venueKey, this.kitchenDevicePreferences);
		this.kitchenDevicePreferences = new VenueKitchenDevicePreferences(resp);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `FocusKitchen settings saved successfully.` });
		this.changesToSave = false;
	}
}
